// removed by extract-text-webpack-plugin
module.exports = {"classSpinner":"Spinner-classSpinner-b1e5c99e"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Spinner.scss
// module id = 880
// module chunks = 0